/* eslint-disable react/destructuring-assignment */
import React from 'react';
import PropTypes from 'prop-types';

import gql from 'graphql-tag';

import SvgCompose from '../Svg/SvgCompose';
import RakutenSisters from './components/RakutenSisters';
import SearchCtn from './components/SearchCtn';
import NavAndMenuCtn from './components/NavAndMenuCtn';
import t from '../../css/global.module.css';
import s from './header.module.css';
import StoreHelper from '../../modules/header/helpers/storeHelper';
import TechService from '../../modules/common/services/techService';
import QaTracker from '../../tracking/qa/qaTracker';
import glossaryTagQA from '../../tracking/qa/glossaryTagQA';
import GenericService from '../../modules/common/services/genericService';
import HeaderStatic from './Header.static';
import { getJsonLdWebSite } from '../MicroData/microDatas';

class Header extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      suggestOpen: false,
      categories: [],
    };
    this.handlerFocus = this.handlerFocus.bind(this);
    this.storeHelper = new StoreHelper(
      this.props.header,
      this.props.dispatch,
      this.props.externals,
    );
  }

  getChildContext() {
    const universe = this.getUniverse();
    let isObfuscationActive = true;
    if (
      this.props.header
      && this.props.header.featureFlipping
      && this.props.header.featureFlipping.obfuscation
    ) {
      isObfuscationActive = this.props.header.featureFlipping.obfuscation
        .isActive;
    }
    return {
      storeHelper: this.storeHelper,
      md: this.props.md,
      externals: this.props.externals,
      universe,
      // On affiche les liens si l'obfuscation n'est pas actif ou si on est sur la home
      displayLink: isObfuscationActive || universe === undefined,
    };
  }

  /**
   * Compatible with react 16
   */
  componentDidMount() {
    this.setState({ menuLoadTrigger: false });

    const script = document.createElement('script');
    script.src = `${GenericService.getCdn()}/javascripts/usersonly/LinkManager.js`;
    script.async = true;
    script.onload = () => window.convertSpan();

    document.body.appendChild(script);
  }


  componentWillReceiveProps(nextProps) {
    const doCloseMenu = this.storeHelper.closeMenu;
    this.storeHelper = new StoreHelper(
      nextProps.header,
      nextProps.dispatch,
      nextProps.externals,
    );
    this.storeHelper.defineCloseMenu(doCloseMenu); // proagate "force close menu temporary hack"
  }

  componentDidUpdate() {
    // TODO this could be delayed or even loaded on demand
    const instance = TechService.getBrowserInstance();
    // call ws to obtain menu data
    if (!this.state.menuLoadTrigger) {
      if (this.props.mdMatchesBrowser) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ menuLoadTrigger: true });
        if (!this.props.md.isBot) {
          instance.menu().then((json) => {
            const menu = json.menu || {};
            // debug(`menu received menu=${JSON.stringify(menu)}`);
            if (menu.categories) {
              /* eslint-disable react/no-did-mount-set-state */
              this.setState({ categories: menu.categories });
            }
          });
        }
      }
    }
  }

  getUniverse() {
    if (this.props.data && this.props.data.isHome) {
      // TODO change isHome
      return undefined;
    }
    if (this.props.navandsearch && this.props.navandsearch.result) {
      if (
        this.props.navandsearch.result.params
        && this.props.navandsearch.result.params.universe
      ) {
        // Cas de la nav
        return this.props.navandsearch.result.params.universe;
      }
      if (
        this.props.navandsearch.result.breadcrumbs
        && this.props.navandsearch.result.breadcrumbs.length >= 2
        && this.props.navandsearch.result.breadcrumbs[1].url
      ) {
        // Cas de la search
        return GenericService.extractUniverse(
          this.props.navandsearch.result.breadcrumbs[1].url,
        );
      }
    }
    if (
      this.props.router
      && this.props.router.location
      && this.props.router.location.pathname
    ) {
      // Cas de la page event
      return GenericService.extractUniverse(
        this.props.router.location.pathname,
      );
    }
    return '';
  }

  handlerFocus(booleanStatus) {
    this.setState({
      suggestOpen: booleanStatus,
    });
  }

  renderLogoAlone() {
    const hideWhenSuggestOpened = this.state.suggestOpen
      ? `${t['helper_hide-BelowDesktop']} ${t.relative}`
      : `${t.relative}`;
    return (
      <a
        href={HeaderStatic.logo.link}
        title="Rakuten"
        className={`${t['items-center']} ${hideWhenSuggestOpened}`}
      >
        <QaTracker tagName={glossaryTagQA.header.logo}>
          <SvgCompose
            className={`${s.logo} ${s.mh_logo}`}
            iconUri={HeaderStatic.logo.icon}
            activeUri={HeaderStatic.logo.icon}
            alt="Rakuten - Achat et vente en ligne de produits neufs et d'occasion"
            active={false}
          />
          <span className={s.srOnly}>Rakuten group</span>
        </QaTracker>
      </a>
    );
  }

  renderLogo() {
    if (this.props.data && this.props.data.isHome) {
      return <h1 className={t.ma0}>{this.renderLogoAlone()}</h1>;
    }
    return this.renderLogoAlone();
  }

  renderHeader() {
    const {
      personalized,
      data: { ...others },
    } = this.props;
    const { persistedSearch, featureFlipping, merchantCenterBetaTesters } = this.props.header;
    const otherProps = Object.assign({}, others);
    otherProps.menu = Object.assign({}, otherProps.menu);
    if (
      !Array.isArray(otherProps.menu.categories)
      || otherProps.menu.categories.length === 0
    ) {
      otherProps.menu.categories = this.state.categories;
    }
    let conversationIsActive = false;
    let sellHomeRedirectionIsActive = false;
    const merchantCenterIsActive = featureFlipping?.merchantCenter?.isActive || false;
    if (featureFlipping && featureFlipping.conversation) {
      conversationIsActive = featureFlipping.conversation.isActive;
    }
    if (featureFlipping && featureFlipping.sellHomeRedirection) {
      sellHomeRedirectionIsActive = featureFlipping.sellHomeRedirection.isActive;
    }

    const hideWhenSuggestOpened = this.state.suggestOpen
      ? `${t['helper_hide-BelowDesktop']} ${t.relative}`
      : t.relative;
    const isInternalSearchActive = true;
    const microdataWebSite = getJsonLdWebSite();

    return (
      <header
        className={`${t['bg-white']} ${t['z-999']} ${t.relative} ${t.bb} ${t['b--moon-gray']}`}
      >
        <div
          className={`${t.flex} ${t['justify-between']} ${t['items-center']}`}
        >
          {this.renderLogo()}
          <RakutenSisters className={hideWhenSuggestOpened} />
          <SearchCtn
            handlerFocus={this.handlerFocus}
            isNav={
              this.props.navandsearch.result
                ? this.props.navandsearch.result.params.nav
                : false
            }
            internalSearchIsActive={isInternalSearchActive}
            {...HeaderStatic.search}
            persistedSearch={persistedSearch}
            className={`${s.flex_grow} ${s.mr_search}`}
          />
        </div>
        <NavAndMenuCtn
          personalized={personalized}
          {...otherProps}
          searchHasFocus={this.props.header.hasFocus}
          helpLink={this.props.data.helpLink}
          conversationIsActive={conversationIsActive}
          merchantCenterIsActive={merchantCenterIsActive}
          merchantCenterBetaTesters={merchantCenterBetaTesters}
          sellHomeRedirectionIsActive={sellHomeRedirectionIsActive}
        />
        <script
          type="application/ld+json"
          /* eslint-disable react/no-danger */
          dangerouslySetInnerHTML={{ __html: microdataWebSite }}
          /* eslint-enable react/no-danger */
        />
      </header>
    );
  }

  render() {
    if (
      this.props.router.location
      && this.props.router.location.state
      && this.props.router.location.state.toggleFiltersAndUniverses
        ? !this.props.router.location.state.toggleFiltersAndUniverses
        : true
    ) {
      if (this.props.data && this.props.header && this.props.header.visible) {
        return this.renderHeader();
      }
    }
    return null;
  }
}

Header.personalizedFraments = {
  cart: gql`
    fragment HeaderCart on Cart {
      nbProducts
    }
  `,
  cartNotifications: gql`
    fragment HeaderCartNotification on CartNotification {
      nbProducts
    }
  `,
  profile: gql`
    fragment HeaderProfile on Profile {
      firstNameOrPseudo
      actionsTotalCount
      isPro
    }
  `,
  priceClub: gql`
    fragment HederPriceClub on Club {
      isSubscribed
    }
  `,
};


Header.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  header: PropTypes.shape({
    hasFocus: PropTypes.bool,
    visible: PropTypes.bool,
    persistedSearch: PropTypes.string,
    merchantCenterBetaTesters: PropTypes.arrayOf(PropTypes.string).isRequired,
    featureFlipping: PropTypes.shape({
      conversation: PropTypes.shape({
        isActive: PropTypes.bool,
      }),
      merchantCenter: PropTypes.shape({
        isActive: PropTypes.bool,
      }),
      obfuscation: PropTypes.shape({
        isActive: PropTypes.bool,
      }),
      sellHomeRedirection: PropTypes.shape({
        isActive: PropTypes.bool,
      }),
    }),
  }),
  personalized: PropTypes.shape({
    cart: PropTypes.shape({
      nbProducts: PropTypes.number,
    }),
    cartNotifications: PropTypes.shape({
      nbProducts: PropTypes.number,
    }),
    profile: PropTypes.shape({
      actionsTotalCount: PropTypes.number,
      firstNameOrPseudo: PropTypes.string,
      isPro: PropTypes.bool,
    }),
  }),
  externals: PropTypes.object,
  data: PropTypes.shape({
    isHome: PropTypes.bool,
    helpLink: PropTypes.string,
  }),
  md: PropTypes.object,
  mdMatchesBrowser: PropTypes.bool.isRequired,
  navandsearch: PropTypes.object,
  router: PropTypes.object,
  /* eslint-enable react/forbid-prop-types */
  dispatch: PropTypes.func.isRequired,
  initalAction: PropTypes.func,
};

Header.childContextTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  storeHelper: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  md: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  externals: PropTypes.object,
  universe: PropTypes.string,
  displayLink: PropTypes.bool,
};

Header.defaultProps = {

  header: {
    hasFocus: false,
    visible: true,
    persistedSearch: null,
    featureFlipping: {
      obfuscation: {
        isActive: true,
      },
      sellHomeRedirection: {
        isActive: false,
      },
    },
  },
  data: {
    isHome: false,
    helpLink: undefined,
  },
  md: {},
  externals: {},
  navandsearch: {},
  router: { location: { state: { toggleFiltersAndUniverses: false } } },
  initalAction: null,
  personalized: {},
};


export default Header;
